import cn from 'clsx'
import s from './StaticPage.module.scss'
import { FC } from 'react'
import { FullHeightSection, Text, CustomImage, Container } from '@components/ui'
import { CustomImageProps } from '@components/ui/CustomImage/CustomImage'
import { PrivacyPage, TermsConditionsPage } from '@generated/model/models'

type StaticPageProps = {
  data?: PrivacyPage | TermsConditionsPage
  children?: any
  id: string
  fullPageHero?: boolean
}

const StaticPage: FC<StaticPageProps> = ({ data, children, id, fullPageHero = true }) => {
  return (
    <>
      <FullHeightSection
        className={cn(s.root, s.fullHeightSection, { [s.halfPageHero]: !fullPageHero })}
        image={data as CustomImageProps}
        imageClassName={s.image}
        slideIndex={0}
        id={id}
      >
        <Text html={data?.title} className={s.title} variant="pageHeading" />
      </FullHeightSection>
      <div className={s.root}>
        <Text html={data?.detail} className={s.detail} variant="smallText" />
      </div>
    </>
  )
}

export default StaticPage
